import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, translate, groupBy } from "../../utils/useful";
import FixedView from "../FixedView";


class MultiSelectInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        // lastNewId: 0

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            // document.addEventListener('mousedown', this.fixedView.hideView);
            // window.addEventListener('scroll', this.fixedView.showView, true);
            // this.getPosition()
            this.fixedView.showView()

        } else {
            // document.removeEventListener('mousedown', this.fixedView.hideView);
            // window.removeEventListener('scroll', this.fixedView.showView);
            this.fixedView.hideView()


        }


        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);
            // this.refs.icon.classList.toggle("rotate-180")
        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue, dontOpen) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            if (!dontOpen) {
                this.toggleOpen(true)
            }
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            // this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local" || !this.props.header.information.type) {

                let options = []
                let choosen = []

                if (this.props.header.information.items && this.props.header.information.items.length > 0) {
                    options = this.props.header.information.items
                }

                if (this.props.title && Array.isArray(this.props.title)) {
                    this.props.title.forEach(element => {
                        choosen.push({ title: element, value: element })
                    });
                }
                if (this.props.data && Array.isArray(this.props.data)) {
                    this.props.data.forEach(element => {
                        this.props.header.information.items.forEach(item => {
                            if (element == item.value) {
                                choosen.push({ title: item.title, value: element })
                            }
                        });
                    });
                }
                // console.log(this.props.data, this.props.header.information.items)
                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch()
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : (this.props.header.information.filter ? JSON.parse(JSON.stringify(this.props.header.information.filter)) : null)

        // console.log(filter)
        if (filter && typeof filter == 'object') {
            for (const [key, value] of Object.entries(filter)) {
                // console.log(key, value)
                if (/\{\{(.*?)\}\}/.test(value)) {
                    if (this.props.variables) {
                        // filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        filter[key] = getObject(this.props.variables, value.replace(/{/g, '').replace(/}/g, ''))

                    }
                }
            }
        }
        // console.log(filter)
        // console.log(address)

        // console.log(this.props.header.information.address, filter, )

        HttpService.request(address, filter, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })

            // console.log(fetchError)
            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            var newData = []
            fetchResult.info.forEach(element => {

                let myData = {}

                Object.entries(this.props.header.information.fields)?.map(([key, value]) => {
                    myData[key] = getObject(element, value)
                })

                // console.log(myData)
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)
                newData.push(myData)

                // newData.push({ value: newValue, title: newTitle })
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)

                // newData.push({ value: newValue, title: newTitle })
            });

            // console.log(this.props.data)

            if (Array.isArray(this.props.data)) {
                let choosen = []
                this.props.data.forEach(oneTitle => {
                    let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                    newData.forEach(oneNewData => {

                        if (oneNewData.value == oneTitleId) {
                            choosen.push({ title: oneNewData.title, value: oneTitleId })
                        }
                    });

                })
                this.setState({ choosen })
                // console.log(choosen)


            }


            let groupByArray = this.props.header?.information?.groupBy
            if (groupByArray) {

                let groupByKeys = []
                let groupByHeaders = []

                groupByArray.forEach(groupByItem => {
                    groupByKeys.push(groupByItem.key)
                    groupByHeaders.push(groupByItem)
                });

                groupBy(newData, groupByHeaders, groupByKeys, 0, (groupedOptions) => {
                    // console.log(groupedOptions)
                    this.setState({ groupedOptions })


                })
            } else {
                this.setState({ groupedOptions: null })

            }


            this.setState({ options: newData })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }



    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        this.state.choosen.forEach(element => {
            choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
            // choosen.push((element.value))

        });
        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }


    renderOption(options, group, level) {

        return (
            <div className="w-100 mt-2">
                {group && (
                    <p className="text-bold font-size-14 mb-1" style={{ paddingLeft: level == null ? 12 : ((level ?? 0) * 10) + 3, paddingRight: level == null ? 12 : ((level ?? 0) * 10) + 10, }}>{checkTranslation(group.label)}</p>
                )}
                {Array.isArray(options) && (
                    options.map((prop, index) => {
                        let selected = false
                        for (var i = 0; i < this.state.choosen.length; i++) {

                            if (prop.value == this.state.choosen[i].value)
                                selected = true
                        }
                        return (
                            <div key={index} onClick={() => this.changeItem(prop, selected)} className=" py-2 cursor-pointer select-item-hover " style={{ paddingLeft: level == null ? 15 : ((level ?? 0) * 10) + 10, paddingRight: level == null ? 15 : ((level ?? 0) * 10) + 10, backgroundColor: selected ? '#78b2d030' : null, borderBottom: '1px solid #fff' }}>
                                <p className="main-c2 text-small" style={{}}>{checkTranslation(prop.title)}</p>
                                {prop.description && (
                                    <p className=" text-smaller text-capitalize" style={{ color: '#777' }}>{checkTranslation(prop.description)}</p>
                                )}
                            </div>
                        )
                    })
                )}

                {(!Array.isArray(options) && options != null && typeof options == 'object') && Object.entries(options)?.map(([key, value], index) => {
                    return this.renderOption(options[key]?.children, options[key], (level + 1))
                })}


            </div>
        )
    }

    render() {


        return (
            <div ref={el => this.currentNode = el} className='mt-0 w-100 h-100 ' style={{ position: 'relative' }} onClick={() => {
                // if (!this.props.data || typeof this.props.data != 'object') {
                this.toggleOpen(true)
                // }
            }} >
                {/* <div ref={ref => this.setWrapperRef(ref)} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} > */}


                {this.props.header.information.placeholder && !this.state.choosen?.length && (
                    <div className="h-100 flexc w-100 cursor-pointer" style={{ top: 0, padding: '4px 0px 3px 0px' }}>
                        {/* <span style={{ opacity: 0 }}>0</span> */}
                        <p className={' mrd-1 mld-1 placeholder w-100 '}>{checkTextTranslation(this.props.header.information.placeholder)}</p>
                    </div>
                )}

                <div className="wrapper w-100"  >
                    <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        {this.state.choosen.map((prop, index) => {
                            return (
                                <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                    <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                        <button onClick={(e) => { e.stopPropagation(); this.changeItem(prop, true, null, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                            <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} />
                                        </button>


                                        <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{checkTranslation(prop.title)}</p>


                                        {/* <img src="/assets/icons/close.svg" onClick={() => this.removeItem(index)} style={{ padding: 2, paddingLeft: 0, color: '#78b2d0', width: 18, height: 18 }} /> */}
                                    </div>
                                    {/* {index != this.state.choosen.length - 1 && (
                                        <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>

                                    )} */}
                                </div>
                            )
                        })}
                        {/* <div className={"position-relative mt-0 mld-1 "}> */}
                        {/* {!this.state.isFinal && (
                                <input ref={'input'} value={this.state.title} onFocus={() => { this.toggleOpen() }} onInput={event => this.search(event.target.value)} onChange={e => { this.props.changeValue(this.props.headerkey, e.target.value) }} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                            )} */}
                        {this.state.isLoading && (

                            <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                <Loader
                                    type="Oval"
                                    color="rgba(0,122,255,1)"
                                    height="20"
                                    width="20"
                                />
                            </div>
                        )}
                        {/* </div> */}
                        {this.state.isFinal && (<i className="fa fa-check-circle mld-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}

                    </div>

                    {/* {this.state.isOpen && ( */}
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={30} zIndex={15} xOffset={0} minWidth={160} maxWidth={300} rightAlign={false}>

                        <div style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40 }}>
                            <div className={'search-drop-down   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>
                                {this.props.header.information.isSearchable && (
                                    <input onChange={event => this.search(event.target.value)} placeholder={translate("search")} style={{ fontSize: 14, alignSelf: 'stratch', padding: 5, height: 35, backgroundColor: '', border: '0px', borderBottom: '1px solid #eee' }} className={'text-start text-semibold px-3'} />
                                )}

                                {this.state.groupedOptions ? (
                                    <div>
                                        {Object.values(this.state.groupedOptions).map((group, index) => {
                                            return (
                                                this.renderOption(group.children, group, 1)
                                            )
                                        })}
                                    </div>
                                ) : (
                                    this.renderOption(this.state.options)
                                )}

                                {this.state.options.length == 0 && (
                                    <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                        {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                                    </div>
                                )}

                            </div>
                        </div>
                    </FixedView>
                    {/* )} */}

                </div>



            </div>
        );
    }
}


export default MultiSelectInput;
